import { useEffect } from 'react';
import { NewModal, useModal } from 'material-hu';
import { useIdleTimer } from 'react-idle-timer';
import { useAuth } from 'src/contexts/JWTContext';
import useNewTheme from 'src/hooks/useNewTheme';
import { useTranslation } from 'src/hooks/useInactivityTimer/i18n';
import { logEvent } from 'src/config/logging';
import { EventName } from 'src/types/amplitude';
import { clearInactivityStorage } from './utils';

const useInactivityTimer = () => {
  const { logout, instance } = useAuth();
  const NewThemeProvider = useNewTheme();
  const { t } = useTranslation();
  const modal = useModal(NewModal, null, {
    title: t('TITLE'),
    textBody: t('BODY'),
    primaryButtonProps: {
      children: t('LOG_IN'),
      onClick: () => modal.closeModal(),
    },
  });

  const onIdle = async () => {
    logEvent(EventName.USER_LOGOUT_INACTIVITY);
    await logout(true);
    modal.showModal();
    clearInactivityStorage();
  };

  const timeout = 1000 * 60 * (instance?.userInactivity || 0);
  const disabled = !timeout;

  useEffect(() => {
    if (!disabled) {
      // user reopened the tab or logged back in
      const nextLogout = parseInt(localStorage.getItem('nextLogout') || '0');
      if (!nextLogout) {
        return;
      }
      if (nextLogout < new Date().getTime()) {
        onIdle();
      }
    }
  }, [disabled]);

  const saveNextLogout = () => {
    localStorage.setItem(
      'nextLogout',
      (new Date().getTime() + timeout).toString(),
    );
  };

  useIdleTimer({
    timeout,
    onAction: saveNextLogout,
    onIdle,
    throttle: 1000, // run onAction once per second at the most
    startManually: disabled,
    crossTab: true, // using react-idle-timer v5.3 because crossTab doesn't work on newer versions
  });

  return <NewThemeProvider>{modal.modal}</NewThemeProvider>;
};

export default useInactivityTimer;
